// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type IdentityPaths = paths;
export const IDENTITY_SERVICE = "identity" as const;

/** Typed openapi-fetch client for the identity service (schema `identity`). */
export function createIdentityClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("identity", options);
}

export type IdentityClient = ReturnType<typeof createIdentityClient>;
